export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8257.9cff7310.jpg";